<template>
  <div class="form-control-plaintext text-break">{{ value }}</div>
</template>

<script>
export default {
  name: "ReadOnlyTextarea",
  props: {
    value: {
      type: [String, null],
      required: true
    }
  },
}
</script>
